import { theme as antdTheme, ThemeConfig } from 'antd';
import { lightThemePalette } from './palette';

export const lightTheme: ThemeConfig = {
  algorithm: antdTheme.defaultAlgorithm,
  token: {
    colorBgLayout: lightThemePalette.bgPrimary,
    colorBgContainer: lightThemePalette.bgSecondary,
    colorBgSpotlight: lightThemePalette.bgDisabled,
    colorText: lightThemePalette.textPrimary,
    colorTextSecondary: lightThemePalette.textSecondary,
    colorTextDisabled: lightThemePalette.textDisabled,
    colorTextPlaceholder: lightThemePalette.placeHolderText,
    colorPrimary: lightThemePalette.borderPrimary,
    colorSuccess: lightThemePalette.textSuccess,
    colorInfo: lightThemePalette.textInfo,
    colorError: lightThemePalette.textError,
    colorBorder: lightThemePalette.borderDisabled,
    fontFamily: lightThemePalette.fontFamily,
  },
  components: {
    Layout: {
      headerBg: lightThemePalette.bgPrimary,
      headerPadding: '0 24px',
      headerHeight: 64,
    },
  },
  hashed: false,
};

export const emotionTheme = {
  colors: {
    // Background Colors

    bgPrimary: '#ffffff',
    bgSecondary: '#f0f2f5',
    bgDisabled: '#f4f6fa',

    // Text Colors

    textPrimary: '#1f2023',
    textSecondary: '#4a5b6b',
    textDisabled: '#718191',
    placeHolderText: '#707073',
    textSuccess: '#00a130',
    textInfo: '#237bf8',
    textError: '#ff2d39',

    // Border Colors

    borderPrimary: '#237bf8',
    borderDisabled: '#adb5bd',
    borderSuccess: '#00a130',
    borderError: '#ff2d39',
  },
  spacing: (val: number) => val * 8,
};
